import QuestionAndAnswer from './QuestionAndAnswer';

export { default as typeformResponseToFields } from './typeformResponseToFields';
export { default as anvilResponseToFields } from './anvilResponseToFields';

export default QuestionAndAnswer;
